import React from 'react';
import { createRoot } from 'react-dom/client';
import RoutesWithAuth from './RoutesWithAuth';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<RoutesWithAuth />);
